import React from 'react'
export const QA_ID_PREFIX = "InputErrorText";

function InputErrorText({
    message,
    className,
}) {
    return (
        <span 
            className={`ld_Ev ld_Ex ld_JA ld_JC ld_EO ${className}`} 
            id="react-aria9658367578-:r4:"
            data-testid={`${QA_ID_PREFIX}-container`}
        >
            <span 
                className="ld_FC"
                data-testid={`${QA_ID_PREFIX}-label`}
            >
                Error: 
            </span>
            <svg
                fill="currentColor"
                height="1em"
                viewBox="0 0 16 16"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="presentation"
                className="ld_JD"
                data-testid={`${QA_ID_PREFIX}-icon`}
                style={{
                fontSize: "1rem",
                verticalAlign: "-0.175em",
                }}
            >
                <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m-.631-5.804L7.083 4.12h1.834l-.274 5.076zM8 11.872q-.429 0-.714-.24Q7 11.38 7 10.936q0-.42.286-.684.285-.264.714-.264.417 0 .702.264a.87.87 0 0 1 .298.684q0 .444-.298.696-.285.24-.702.24" />
            </svg>
            <span data-testid={`${QA_ID_PREFIX}-message`}>
                {message}
            </span>
        </span>
    )
}

export default InputErrorText;
